// extracted by mini-css-extract-plugin
export var actionText = "_nu-4";
export var container = "_nu-0";
export var leftSection = "_nu-1";
export var rightSection = "_nu-2";
export var settingsButton = "_nu-6";
export var settingsIcon = "_nu-7";
export var shortcut = "_nu-5";
export var shortcutGroup = "_nu-3";